import React, { Component } from "react";
import { connect } from "react-redux";
import DrawDetail from "../Modal/DrawDetail";
import FreezeDetail from "../Modal/FreezeDetail";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import {
  getMembersInfo,
  selectMembersInfo,
  selectMemberInfo,
  getDrawDetail,
  getFreezeDetail,
  getDocumentFile,
  selectDocumentFile,
} from "../../../state/ducks/member/index";

class Expenses extends Component {
  state = {
    cekilisTarihi: null,
    uye: "ÜYELİK BİLGİLERİM",
    currency: "₺",
  };
  componentDidMount() {
    const { match } = this.props;
    var id = match?.params?.id;
    this.props.getMembersInfo(id);

    let result = this.props.member.info.filter((item) => {
      return item.id.toString() === id;
    });

    if (result != null && result[0] != null) {
      this.setState({ uye: result[0] });
      this.setState({
        currency: result[0].orgTurId === 3 ? "XAU" : "₺",
      });
    }
  }

  setDrawId = (drawId, cekilisTarihi) => {
    const { match } = this.props;
    var id = match?.params?.id;
    this.props.getDrawDetail(id, drawId);
    this.setState({ cekilisTarihi: cekilisTarihi });
  };

  getFreezeDetail = (source) => {
    const { match } = this.props;
    var id = match?.params?.id;
    this.props.getFreezeDetail(id, source);
  };

  getDocumentFile = (documentId, documentName) => {
    var ext = documentName.substr(documentName.lastIndexOf('.') + 1);
    this.props.getDocumentFile(documentId, ext, documentName);
  };

  render() {
    const { members } = this.props;
    return (
      <div className="container-fluid">
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            {/* KUTU 3  EV */}

            <div className={
              this.state.uye.orgTurId === 2 ? (
                "row no-gutters t-kutu t-yesilCizgi"

              ) : this.state.uye.orgTurId === 3 ? (
                "row no-gutters t-kutu t-turuncuCizgi"

              ) : this.state.uye.orgTurId === 1 ? (
                "row no-gutters t-kutu t-mavicizgi"

              ) :
                ("")
            }>
              <div className="col bosluk backbottom">
                {/* içerikler */}
                {/* Başlık */}
                <div className="row no-gutters align-items-center">
                  <div clss="col-auto">
                    {this.state.uye.orgTurId === 2 ? (
                      <i className="t-icon-home1 icon" />
                    ) :
                      ("")
                    }
                    {this.state.uye.orgTurId === 3 ? (
                      <img
                        src="/assets/img/svg/icon_kabe.svg"
                        style={{ width: 70, height: "auto", paddingRight: 10 }}
                      />
                    ) :
                      ("")
                    }
                    {this.state.uye.orgTurId === 1 ? (
                      <i className="t-icon-truck1 icon" />
                    ) :
                      ("")
                    }
                  </div>
                  <div className="col d-flex flex-column justify-content-center">
                    <div className="baslik px-0">{this.state.uye.orgSis} {" ("}
                      <NumberFormat
                        decimalSeparator={false}
                        thousandSeparator={"."}
                        value={this.state.uye.uyeNo}
                        displayType={"text"}
                      />{")"}</div>
                    <span className="altBaslik">
                      {this.state.uye.kayitTuruId !== 10 &&
                        this.state.uye.kayitTuruId !== 11
                        ? "Planlanan "
                        : ""}
                      Teslimat Tarihi : <br />  <strong>{this.state.uye.teslimTarihi}</strong>
                    </span>
                  </div>
                  <div className="col-auto ">

                  <Link to="/Home/MemberInfo" className="t-icButonTrunucu mx-auto">
                  <i className="t-icon-arrow-left2"  style={{padding:"5px"}}/>
                    {" "}
                     Geri

                  </Link>
                </div>
                </div>
          
                <div className="col-12 t-hrUzun">
                  <hr />
                </div>
                {/* tablı Sistem */}
                <nav>
                  <div
                    className="nav nav-pills nav-fill nav-justified t-tablar"
                    id="nav-tab"
                    role="tablist"
                  >
                    <a
                      className={
                        this.state.uye.kayitTuruId === 8
                          ? "nav-link"
                          : "nav-link active"
                      }
                      data-toggle="tab"
                      data-target="#odemeler"
                      hidden={this.state.uye.kayitTuruId === 8}
                    >
                      ÖDEMELER
                    </a>
                    <a
                      className={
                        this.state.uye.kayitTuruId !== 8
                          ? "nav-link"
                          : "nav-link active"
                      }
                      data-toggle="tab"
                      data-target="#iadeler"
                      hidden={this.state.uye.kayitTuruId !== 8}
                    >
                      İADELER
                    </a>
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      data-target="#masraflar"
                    >
                      MASRAFLAR
                    </a>
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      data-target="#hareketler"

                    >
                      HAREKETLER
                    </a>
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      data-target="#taksiterteleme"
                      hidden={
                        this.state.uye.kayitTuruId === 8 ||
                        this.state.uye.dondurulanAy === null ||
                        this.state.uye.dondurulanAy === 0
                      }
                    >
                      TAKSİT ERTELEME
                    </a>
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      data-target="#cekilisler"
                      hidden={
                        this.state.uye.kayitTuruId === 8 ||
                        members?.draws === null ||
                        members?.draws?.length === 0
                      }
                    >
                      ÇEKİLİŞLER
                    </a>
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      data-target="#teslimat"
                      hidden={
                        this.state.uye.kayitTuruId === 8 ||
                        members?.deliveryStatements?.list === null ||
                        members?.deliveryStatements?.list.length === 0
                      }
                    >
                      TESLİMAT
                    </a>
                    <a
                      className="nav-link"
                      data-toggle="tab"
                      data-target="#policeler"
                      hidden={
                        this.state.uye.kayitTuruId === 8 ||
                        members?.documents === null ||
                        members?.documents?.length === 0
                      }
                    >
                      POLİÇELER
                    </a>
                  </div>
                </nav>
                <div className="tab-content p-2" id="nav-tabContent">
                  {/* Ödemeler Tablosu */}
                  <div
                    className={
                      this.state.uye.kayitTuruId === 8
                        ? "tab-pane fade show"
                        : "tab-pane fade show active"
                    }
                    id="odemeler">
                    <table className="table table-sm t-tablo">
                      <thead>
                        <tr>
                          <th scope="col">Dönem</th>
                          <th scope="col">Tür</th>
                          <th scope="col">Vade Tarihi</th>
                          <th scope="col">Ödenen ({this.state.currency})</th>
                          <th scope="col">Kalan ({this.state.currency})</th>

                        </tr>
                      </thead>
                      <tbody>
                        {members?.memberPayments?.list &&
                          members.memberPayments.list.map((item) => {
                            let classTaksit = "";
                            if (item.tur !== "TAKSIT" && item.kalanTutar !== 0)
                              classTaksit += "taksit_tipler";
                            if (item.tur !== "TAKSIT" && item.kalanTutar === 0)
                              classTaksit += " taksit_biten-tipler";
                            if (item.kalanTutar === 0)
                              classTaksit += " t-odendi";
                            return (
                              <tr key={item.id} className={classTaksit}>
                                <td>
                                  {item.tur !== "TAKSIT" ? (
                                    <i className="t-icon-star-full"></i>
                                  ) : (
                                    item.donem
                                  )}
                                </td>
                                <td>{item.tur}</td>
                                <td>{item.vadeTarihi}</td>
                                <td>
                                  <NumberFormat
                                    decimalSeparator={","}
                                    thousandSeparator={"."}
                                    value={item.tutar}
                                    displayType={"text"}
                                  />
                                </td>
                                <td>
                                  <NumberFormat
                                    decimalSeparator={","}
                                    thousandSeparator={"."}
                                    value={item.kalanTutar}
                                    displayType={"text"}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        <tr>
                          <th scope="col" colSpan={2} />
                          <th scope="col">Toplam</th>
                          <th>
                            <NumberFormat
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              value={members?.memberPayments?.tutarToplam}
                              displayType={"text"}
                            />
                          </th>
                          <th>
                            <NumberFormat
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              value={members?.memberPayments?.kalanTutarToplam}
                              displayType={"text"}
                            />
                          </th>
                          <th scope="col" />
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {/* İadeler*/}
                  <div
                    className={
                      this.state.uye.kayitTuruId !== 8
                        ? "tab-pane fade show"
                        : "tab-pane fade show active "
                    }
                    id="iadeler">
                    <table className="table table-sm t-tablo">
                      <thead>
                        <tr>
                          <th scope="col">Tür</th>
                          <th scope="col">Vade Tarihi</th>
                          <th scope="col">İade Edilen ({this.state.currency})</th>
                        </tr>
                      </thead>
                      <tbody>
                        {members?.returns?.list &&
                          members.returns.list.map((item) => {
                            return (
                              <tr key={item.id} className="t-odendi">
                                <td>{item.islemTipi}</td>
                                <td>{item.vadeTarihi}</td>
                                <td>
                                  <NumberFormat
                                    decimalSeparator={","}
                                    thousandSeparator={"."}
                                    value={item.tutar}
                                    displayType={"text"}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        <tr>
                          <th scope="col" />
                          <th scope="col">Toplam</th>
                          <th>
                            <NumberFormat
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              value={members?.returns?.tutarToplam}
                              displayType={"text"}
                            />
                          </th>
                          <th scope="col" />
                        </tr>
                      </tbody>
                    </table>
                    <p
                      className="small font-italic text-muted"
                      hidden={
                        members?.returns?.dilekceTarihi === null ||
                        members?.returns?.dilekceTarihi === ""
                      }
                    >
                      {members?.returns?.dilekceTarihi}
                    </p>
                  </div>
                  {/* Masraflar*/}
                  <div className="tab-pane fade" id="masraflar">
                    <table className="table table-sm t-tablo">
                      <thead>
                        <tr>
                          <th scope="col">Tür</th>
                          <th scope="col">Vade Tarihi</th>
                          <th scope="col">Ödenen ({this.state.currency})</th>
                          <th scope="col">Kalan ({this.state.currency})</th>

                        </tr>
                      </thead>
                      <tbody>
                        {members?.expenses?.list &&
                          members.expenses.list.map((item) => {
                            return (
                              <tr
                                key={item.tur + item.vadeTarihi}
                                className={
                                  item.kalanTutar === 0 ? "t-odendi" : ""
                                }
                              >
                                <td>{item.tur}</td>
                                <td>{item.vadeTarihi}</td>
                                <td>
                                  <NumberFormat
                                    decimalSeparator={","}
                                    thousandSeparator={"."}
                                    value={item.tutar}
                                    displayType={"text"}
                                  />
                                </td>
                                <td>
                                  <NumberFormat
                                    decimalSeparator={","}
                                    thousandSeparator={"."}
                                    value={item.kalanTutar}
                                    displayType={"text"}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        <tr>
                          <th scope="col" />
                          <th scope="col">Toplam</th>
                          <th>
                            <NumberFormat
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              value={members?.expenses?.tutarToplam}
                              displayType={"text"}
                            />
                          </th>
                          <th>
                            <NumberFormat
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              value={members?.expenses?.kalanTutarToplam}
                              displayType={"text"}
                            />
                          </th>
                          <th scope="col" />
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {/* Hareketler*/}
                  <div className="tab-pane fade" id="hareketler">
                    <table className="table table-sm t-tablo">
                      <thead>
                        <tr>
                          <th scope="col">İşlem Tarihi</th>
                          <th scope="col">İşlem Tutarı ({this.state.currency})</th>
                          <th scope="col">Açıklama</th>
                        </tr>
                      </thead>
                      <tbody>
                        {members?.movements &&
                          members.movements.map((item) => {
                            return (
                              <tr key={item.id}>
                                <td>{item.islemTarihi}</td>
                                <td>
                                  <NumberFormat
                                    decimalSeparator={","}
                                    thousandSeparator={"."}
                                    value={item.tutar}
                                    displayType={"text"}
                                  />
                                </td>
                                <td>{item.aciklama}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/*Taksit Erteleme*/}
                  <div className="tab-pane fade" id="taksiterteleme">
                    <table className="table table-sm t-tablo">
                      <thead>
                        <tr>
                          <th scope="col">Erteleme Sebebi</th>
                          <th scope="col">Ay</th>
                          <th scope="col">Detay</th>
                        </tr>
                      </thead>
                      <tbody>
                        {members?.freeze?.list &&
                          members.freeze.list.map((item) => {
                            return (
                              <tr key={item.id} className="t-taksiterteleme">
                                <td>{item.ertelenmeSebebi}</td>
                                <td>{item.ay}</td>
                                <td>
                                  <a
                                    href="#erteleme"
                                    onClick={() =>
                                      this.getFreezeDetail(item.kaynak)
                                    }

                                    data-toggle="modal"
                                    data-target="#ertelemeModalCenter"
                                  >
                                    Detay

                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                        <tr>
                          <th scope="col">Toplam</th>
                          <th>
                            <NumberFormat
                              decimalSeparator={","}
                              thousandSeparator={"."}
                              value={members?.freeze?.toplamAy}
                              displayType={"text"}
                            />
                          </th>
                          <th scope="col" />
                        </tr>
                      </tbody>
                    </table>
                    <br>
                    </br>
                    <p className="small font-italic text-muted">
                      {members?.freeze?.aciklama}
                    </p>
                    <p className="small font-italic text-muted">
                      {members?.freeze?.temsilciBilgi}
                    </p>
                  </div>
                  {/* Çekilişler*/}
                  <div className="tab-pane fade" id="cekilisler">
                    <table className="table table-sm t-tablo">
                      <thead>
                        <tr>
                          <th scope="col">Çekiliş Tarihi</th>
                          <th scope="col">Çekilş Durumu</th>
                          <th scope="col" />
                        </tr>
                      </thead>
                      <tbody>
                        {members?.draws &&
                          members.draws.map((item) => {
                            return (
                              <tr
                                key={item.id}
                                className={
                                  item.cekilisYapildiMi == true && item.ciktiMi ? "t-kazandiniz" : "t-cikmadi"
                                }
                              >
                                <td>
                                  {new Date(
                                    item.cekilisTarihi
                                  ).toLocaleDateString()}
                                </td>
                                <td>
                                  {item.cekilisDurumu}
                                </td>
                                <td>
                                  <a
                                    href="#cekilis"
                                    hidden={item.cekilisYapildiMi == false}
                                    onClick={() =>
                                      this.setDrawId(item.id, item.cekilisTarihi)
                                    }
                                    data-toggle="modal"
                                    data-target="#cekilisModalCenter"

                                  >
                                    Detay

                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* Teslimat */}
                  <div className="tab-pane fade" id="teslimat">
                    {/* Tamamlanma durumu için background divindeki width değeri ve yazının % cinsinden verilmesi gerekli*/}
                    <div className="row no-gutters">
                      <div className="col-12 py-2">
                        <div className="t-oran">
                          <div className="background"
                            style={{
                              width:
                                members?.deliveryStatements?.tamamlanmaOrani +
                                "%",
                            }}
                            aria-valuenow={
                              members?.deliveryStatements?.tamamlanmaOrani
                            }
                            aria-valuemin="0"
                            aria-valuemax="100" />
                          <span>
                            Tamamlanma durumu <strong className="px-2"> {members?.deliveryStatements?.tamamlanmaOrani} %{" "}</strong>

                          </span>

                        </div>


                      </div>
                      <div className="col-12 py-2">
                        <span style={{ fontSize: "initial" }}>
                          Yol haritasına ve gerekli evrak listesine ulaşmak için
                          <a

                            target="_blank"
                            href={
                              this.state.uye.orgTurId === 2
                                ? process.env.PUBLIC_URL +
                                "/assets/docs/evraklistesi-yolharitasi-konut 2_rgb.pdf"
                                : process.env.PUBLIC_URL +
                                "/assets/docs/evraklistesi-yolharitasi-otomobil 2_rgb.pdf"
                            }
                          >
                            <b> tıklayınız.</b>
                          </a>
                        </span>
                      </div>
                    </div>
                    <table className="table table-sm t-tablo">
                      <thead>
                        <tr>
                          <th className="text-left" scope="col">Adımlar</th>
                          <th scope="col">Durum</th>
                          <th scope="col">Tamamlanma Tarihi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {members?.deliveryStatements?.list &&
                          members.deliveryStatements.list.map((item) => {
                            return (
                              <tr
                                key={item.id}
                                className={item.isDurum ? "t-tamamlandi" : "t-eksik"}
                              >
                                <td className="text-left">{item.isTuru}</td>
                                <td>
                                  {item.isDurum ? (
                                    <i className="t-icon-check_circle_outline"></i>
                                  ) : (
                                    <i className="far fa-times-circle text-danger"></i>
                                  )}
                                </td>
                                <td>{item.tamamlanmaTarihi}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* Poliçeler*/}
                  <div className="tab-pane fade" id="policeler">
                    <table className="table table-sm t-tablo">
                      <thead>
                        <tr>
                          <th className="text-left" scope="col">Adı</th>
                          <th scope="col">Türü</th>
                          <th scope="col">Eklenme Tarihi</th>
                          <th scope="col" >İndir</th>
                        </tr>
                      </thead>
                      <tbody>
                        {members?.documents &&
                          members.documents.map((item) => {
                            return (
                              <tr key={item.id} className="t-policeler">
                                <td className="text-left">{item.dosyaAdi}</td>
                                <td>{item.dokumanTurAdi}</td>
                                <td>{item.tarih}</td>
                                <td>
                                  <a
                                    href="#indir"
                                    onClick={() => this.getDocumentFile(item.id, item.dosyaAdi)}
                                  >
                                    <i className="t-icon-folder-download"></i> İndir
                                  </a>
                                </td>
                              </tr>
                            );
                          })}

                      </tbody>
                    </table>
                  </div>
                </div>
                {/* içerikler BİTTİ */}
              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 2 BİTTİ */}
            <DrawDetail cekilisTarihi={this.state.cekilisTarihi}></DrawDetail>
            <FreezeDetail></FreezeDetail>
          </div>
        </div>
        {/* Duyurlar Baslık*/}
        {/* duyrular Bitti*/}
        <div className="row" style={{ height: 30 }} />
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
    members: selectMembersInfo(state),
    file: selectDocumentFile(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMembersInfo: (memberId) => dispatch(getMembersInfo(memberId)),
  getDrawDetail: (memberId, drawId) =>
    dispatch(getDrawDetail(memberId, drawId)),
  getFreezeDetail: (memberId, sourceId) =>
    dispatch(getFreezeDetail(memberId, sourceId)),
  getDocumentFile: (documentId, ext, documentName) => dispatch(getDocumentFile(documentId, ext, documentName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Expenses);
